module.exports = __webpack_public_path__ + "img/DE03973.a70a372c.png";